import axios from 'axios';
import API from "../../services/API";
import Endpoints from "../config/Endpoints";

export default {

    GetRelated: function (pageId, max, type, locale, profile) {
        let url = API.url(
            Endpoints.Related.GetRelatedContent,
            {
                page_id: pageId,
                max: max,
                type: type || 'all',
                lang: locale,
                profile: profile,
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data.data;
            });
    },

    AutocompleteByName: function (query, locale) {
        let url = API.url(
            Endpoints.Content.AutocompleteByName,
            {
                query: query,
                lang: locale
            }
        );

        return axios.get(url)
            .then((res) => res.data.data);
    },

    FetchAllWithType: function (pageType, page, searchTerms, max, sortDirection, locale) {
        let url = API.url(
            Endpoints.Content.FetchAllWithType,
            {
                page_type: pageType,
                page: page,
                search_terms: searchTerms,
                max: max,
                sort: sortDirection,
                lang: locale
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data;
            });
    },

    FetchAllWithTypeAndTaxonomy: function(pageType, page, taxonomy, max, locale, profileSlug, query, letter, exclude){
        let url = API.url(
            Endpoints.Content.FetchAllWithTypeAndTaxonomy,
            {
                page_type: pageType,
                page: page,
                taxonomy: taxonomy,
                max: max,
                lang: locale,
                profile: profileSlug,
                query: query,
                sort: 'desc',
                letter: letter,
                excluded_tags: exclude
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data;
            });
    },

    FetchAllPodcasts: function(page, max, locale, profileSlug, query){
        let url = API.url(
            Endpoints.Content.FetchAllPodcasts,
            {
                page: page,
                max: max,
                lang: locale,
                profile: profileSlug,
                query: query,
                sort: 'desc'
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data;
            });
    },

    GetLatestPosts: function (locale, profile) {
        let url = API.url(Endpoints.Posts.GetLatest,
            {
                lang: locale,
                profile: profile,
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data.data;
            });
    },

    GetTaxonomyPosts: function (locale, profile, taxonomy, types) {
        let url = API.url(Endpoints.Posts.GetTaxonomyPosts,
            {
                lang: locale,
                profile: profile,
                taxonomy: taxonomy,
                types: types,
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data.data;
            });
    },

    GetFeaturedPosts: function (locale, profile, tags) {
        let url = API.url(Endpoints.Posts.GetFeatured,
            {
                lang: locale,
                profile: profile,
                tags: tags
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data.data;
            });
    },

    GetFeaturedProducts: function (locale, tags, products) {
        let url = API.url(Endpoints.Products.GetFeaturedProducts,
            {
                lang: locale,
                tags: tags.toString(),
                products: products.toString(),
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data.data;
            });
    },

    GetProductsBySearchPage: function (tagslug, page, profile) {
        let url = API.url(Endpoints.Products.GetProductsBySearchPage,
            {
                tagslug: tagslug,
                page: page,
                profile: profile
            }
        );

        return axios.get(url)
            .then((res) => {
                return res.data;
            });
    },

    GetStatesAndCities: function () {
        let url = API.url(
            Endpoints.StatesAndCities.GetAll
        );

        return axios.get(url)
            .then((res) => {
                return res.data.response
            });
    },
}
